import { ArrowUpFromLine, ArrowDownToLine, ShoppingCart, Truck, Handshake } from "lucide-react";

export const SERVICES = [
  {
    title: "Export",
    testId: "service-export",
    icon: ArrowUpFromLine,
    content:
      "RKG NATURALS provides export sourcing and supply support for Indian agricultural and natural products. We coordinate product sourcing, quality requirements, packaging and other export-related requirements according to buyer needs. Our focus is reliable supply and smooth international trade support.",
  },
  {
    title: "Import",
    testId: "service-import",
    icon: ArrowDownToLine,
    content:
      "We support import-related sourcing and business coordination for products required from international markets. Requirements can be discussed based on product availability, specifications and business needs.",
  },
  {
    title: "E-Commerce",
    testId: "service-e-commerce",
    icon: ShoppingCart,
    content:
      "RKG NATURALS provides support for e-commerce-oriented product sourcing and supply requirements, helping businesses connect products with wider digital markets and customers.",
  },
  {
    title: "Drop Shipping",
    testId: "service-drop-shipping",
    icon: Truck,
    content:
      "Our drop shipping service supports direct product supply and order fulfillment coordination between suppliers and customers. This model can be arranged according to product availability and customer requirements.",
  },
  {
    title: "Service Provider",
    testId: "service-service-provider",
    icon: Handshake,
    content:
      "RKG NATURALS provides sourcing, product supply, import-export coordination and related business support according to specific requirements. Customized sourcing and supply solutions can also be coordinated where applicable.",
  },
];
